export default __webpack_public_path__ + "static/1555-89bd0555b581b240857ddd7fcebe30f4.gif";